export default __webpack_public_path__ + "images/63_2_image.jpg";